import { Suspense } from 'react';
import { lazy } from 'utils/generic/lazy';
import { ECasinoGameView } from 'interfaces/casino-data';
import { useCasinoGameViewContainerValues } from '../../providers/GameViewContainerProvider';

const { SingleviewManagerInternal } = lazy(
  () => import(/* webpackChunkName: "casino-singleview-manager" */ './manager')
);

export const SingleviewManager = () => {
  const { view } = useCasinoGameViewContainerValues();

  if (view !== ECasinoGameView.SINGLE) {
    return;
  }

  return (
    <Suspense>
      <SingleviewManagerInternal />
    </Suspense>
  );
};
